import React from 'react';
import { TypedMemo } from '../../common/types';

const SMLDebugViewRendererComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <>{children}</>;
};
export const SMLDebugViewRenderer = TypedMemo(SMLDebugViewRendererComponent);
